// App.js

import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
function LoginPage() {
	const auth = useAuth();
	const navigate = useNavigate();

	const logoutRedirectUri =
		process.env.NODE_ENV === "production"
			? "https://magicverse.me"
			: "http://localhost:3000";

	const signOutRedirect = () => {
		const clientId = "63lshnga7pf7jc29penkr0jclf";
		const logoutUri = logoutRedirectUri;
		const cognitoDomain = "https://<user pool domain>";
		window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
			logoutUri
		)}`;
	};

	if (auth.isLoading) {
		return <div>Loading...</div>;
	}

	if (auth.error) {
		return <div>Encountering error... {auth.error.message}</div>;
	}

	if (auth.isAuthenticated) {
		localStorage.setItem("auth_user", JSON.stringify(auth.user));
		return (
			<div>
				<pre> Hello: {auth.user?.profile.email} </pre>
				<pre> ID Token: {auth.user?.id_token} </pre>
				<pre> Access Token: {auth.user?.access_token} </pre>
				<pre> Refresh Token: {auth.user?.refresh_token} </pre>
				<button onClick={() => auth.removeUser()}>Sign out</button>
			</div>
		);
	}

	return (
		<div>
			<button onClick={() => auth.signinRedirect()}>Sign in</button>
			<button onClick={() => signOutRedirect()}>Sign out</button>
		</div>
	);
}

export default LoginPage;
